import React from 'react';
import * as Icon from 'react-feather';
import { NavLink } from "react-router-dom";
import DataTable from 'react-data-table-component';
import { Alert }  from 'reactstrap';
import { TableSearchForm } from '../Common/TableSearchForm';
import { UserActionsButton } from './ActionsButton';

export function UsersList(props) {
    const columns = [
        {
            name: 'Full Name',
            selector: 'name',
            sortable: true,
            ignoreRowClick: true,
            cell: (row) => {
                return <NavLink to={'/users/edit/' + row.id}>{row.firstName} {row.surname}</NavLink>
            }
        },
        {
            name: 'Role',
            selector: 'roles',
            sortable: true,
            cell: (row) => {                
                const roles = Object.entries(row.roles).map(([key, value]) => {
                    return (
                        <span key={key}>
                            {key > 0 && ", "}
                            {value.name}
                        </span>
                    );
                });            
                return roles;
            }
        },
        {
            name: 'Organisation(s)',
            selector: 'tenants',
            sortable: true,
            cell: (row) => {
                const tenants = Object.entries(row.tenants).map(([key, value]) => {
                    return (
                        <span key={key}>
                            {key > 0 && ", "}
                            {value.name}
                        </span>
                    );
                });            
                return tenants;
            }
        },
        {
            name: 'Is Verified',
            selector: 'emailConfirmed',
            sortable: true,
            cell: (row) => {
                if (row.emailConfirmed === true) {
                    return <Icon.CheckCircle style={{color: "#28a745", height: "15px"}}/>
                } else {
                    return <Icon.Circle style={{color: "#dc3445", height: "15px"}}/>
                }
            }
        },
        {
            name: '',
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            cell: (row) => {
                return (
                    <UserActionsButton 
                        user={row} 
                        handleEdit={props.handleEdit} 
                        handleDelete={props.handleDelete}
                        changePassword={props.changePassword}
                    />
                );
            }
        }
    ];

    const hasAny = props.items && props.items.length > 0;

    return (
        <>
            <TableSearchForm handleSearch={props.handleSearch} />
            {
                hasAny ? (
                    <DataTable
                        columns={columns}
                        data={props.items}
                        defaultSortField="name"
                        pagination
                        highlightOnHover
                        noHeader
                        paginationPerPage={50}
                        paginationRowsPerPageOptions={[10, 25, 50, 100]}
                    />
                ) : <Alert color="warning">No Users were found</Alert>
            }
        </>
    );
}

